import React, { useState, useRef } from "react"

import DayPickerInput from "react-day-picker/DayPickerInput"
import { DateUtils } from "react-day-picker"
import dateFnsFormat from "date-fns/format"
import dateFnsParse from "date-fns/parse"
import { parse, isBefore } from "date-fns"
import * as Constants from "../../common/constants"
import { useSelector } from "react-redux"

const DateField = ({ field, form, label, startDate, ...props }) => {
  let planPeriodFrom = useSelector(
    state => state.claimData.claimFireDetail.planPeriodFrom
  )
  let planPeriodTo = useSelector(
    state => state.claimData.claimFireDetail.planPeriodTo
  )
  const FORMAT = "dd/MM/yyyy"
  const elDate = useRef(null)
  const selected = field.value
  const [, setOpen] = useState(false)
  let disableBefore
  let disableAfter

  // Assign disableBefore value
  if (props.disableBefore !== "disable") {
    if (props.disableBefore) {
      if (form.values[props.disableBefore]) {
        disableBefore = form.values[props.disableBefore]
      } else {
        disableBefore = parse(
          props.disableBefore,
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
      }
    } else {
      if (planPeriodFrom)
        disableBefore = parse(
          planPeriodFrom,
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
    }
  }

  // Assign disableAfter value
  if (props.disableAfter !== "disable") {
    if (props.disableAfter) {
      if (form.values[props.disableAfter]) {
        disableAfter = form.values[props.disableAfter]
      } else {
        disableAfter = parse(
          props.disableAfter,
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
      }
    } else {
      if (planPeriodTo)
        disableAfter = parse(
          planPeriodTo,
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
    }
  }

  const parseDate = (str, format, locale) => {
    const parsed = dateFnsParse(str, format, Date.now())
    if (DateUtils.isDate(parsed) && parsed.getFullYear() > 1000) {
      return parsed
    }
    return undefined
  }
  const formatDate = (date, format, locale) => {
    return dateFnsFormat(date, format)
  }
  const handleChange = val => {
    form.setFieldValue(field.name, val)

    // const isValid = props.formIsValid

    //console.log(props.formIsValid)
    // dispatch(
    //   updateCategoryClaimData(
    //     category,
    //     targetCoverageCode,
    //     inputName,
    //     inputValue
    //   )
    // )
  }

  const modifiers = () => {
    let limitedRespond = []
    let limitedDate = {}

    if (disableBefore && props.disableBefore !== "disable") {
      limitedDate.before = disableBefore
    }

    // Set the 'after' date limit based on conditions
    if (props.disableAfter !== "disable") {
      // Check if 'disableAfter' props is not "disable"
      if (!disableAfter || isBefore(new Date(), disableAfter)) {
        // If 'disableAfter' is not set or current date is before 'disableAfter'
        // and future dates are not allowed
        // then limit until today date
        limitedDate.after = new Date()

        // if got provide allowFutureDate
        if (
          props.allowFutureDate !== null &&
          props.allowFutureDate !== undefined &&
          props.allowFutureDate
        ) {
          limitedDate.after = disableAfter
        }
      } else {
        // If 'disableAfter' is set or future dates are allowed
        limitedDate.after = disableAfter
      }
    }
    
    //comment below since hdb fire need requested totally allow future date
    // //If disableBefore and disableAfter prod value not disable
    // if (props.disableBefore !== "disable" && props.disableAfter !== "disable") {
    //   //Disable all days when today is early than limitedDate.before
    //   if (isBefore(new Date(), limitedDate.before)) {
    //     limitedDate.before = new Date()
    //     limitedDate.after = new Date()
    //     limitedRespond.push(new Date())
    //   }
    // }

    limitedRespond.push(limitedDate)
    return limitedRespond
  }

  const getInitialMonth = () => {
    if (props.disableAfter !== "disable") {
      // if (!disableAfter || isBefore(new Date(), disableAfter)) {
      //   return new Date()
      // } else {
      //   return disableAfter
      // }
      //comment above since hdb fire need requested totally allow future date 
      if (!disableAfter) {
        return new Date()
      } else {
        //return disableAfter
        return disableBefore
      }
    }
  }

  // const invalid = form.touched[field.name] && !!form.errors[field.name]
  return (
    <>
      {/* <label style={{ marginBottom: "0px" }}>{label}</label> */}
      <DayPickerInput
        classNames={props.classNames}
        inputProps={{
          required: true,
          readOnly: true,
          name: props.inputProps.name,
          //className: props.className,
        }}
        ref={elDate}
        format={FORMAT}
        autoComplete="new-password"
        value={selected}
        placeholder={`DD/MM/YYYY`}
        formatDate={formatDate}
        parseDate={parseDate}
        //name={props.inputProps.name}
        dayPickerProps={{
          disabledDays: modifiers(),
          initialMonth: getInitialMonth(),
          numberOfMonths: 1,
          onDayClick: () => elDate.current.getInput().focus(),
        }}
        onDayChange={handleChange}
        onDayPickerShow={() => setOpen(false)}
        onDayPickerHide={() => setOpen(false)}
      />
    </>
  )
}
export default DateField
